import { ProductType } from 'src/home_page/components/ProductPop/ProductPop'

export const giftCardsExpandData: ProductType = {
  type: 'product',
  title: 'Gift Cards',
  description:
    'Not sure what to get them? We have you covered with gift cards for anyone!',
  categoryId: '10',
}
